import { ApolloClient } from '@apollo/client';
import { observable, action, runInAction } from 'mobx';
import API from '../core/api';
import { redirectToLogin } from '../core/utils';
import User from '../models/user';

import * as UserQuery from '../core/gql/queries/show-user';
import { toType } from '../core/serialization';

export default class AppStateStore {
  @observable user: User;

  apollo: ApolloClient<any>;

  constructor(apollo?: ApolloClient<any>) {
    this.apollo = apollo;
  }

  async init() {
    const result = await API.get('auth');
    if (result.status === 403) {
      redirectToLogin();
      return false;
    }

    this.loadUser();

    return true;
  }

  @action
  async loadUser() {
    const resp = await this.apollo.query({ query: UserQuery.QUERY });
    const user = toType(resp.data.user, User);
    return runInAction(() => (this.user = user));
  }
}
